import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const MobileSearchWrapper = styled.div`
  display: none;
  margin-right: 16px;
  @media (${mediaQuery.tablet}) {
    display: block;
  }
  .anticon-search {
    margin: 0;
    font-size: 24px;
  }
`;

export const SearchInputArea = styled.div`
  display: flex;
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #d2d6da;
  align-items: center;
  padding: 0 13px 0 17px;
  i {
    font-size: 19px;
    cursor: pointer;
  }
  input {
    flex-grow: 2;
    height: 19px;
    line-height: 19px;
    color: #333f48;
    font-size: 16px;
    height: 18px;
    line-height: 18px;
    font-weight: 300;
    outline: none;
    border: none;
    padding-left: 9px;
    &::placeholder {
      color: #a5adb5;
      font-weight: 300;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
    @media (${mediaQuery.tablet}) {
      line-height: normal;
      height: auto;
    }
  }
`;
